<template>
  <div>
    <transition name="parent-submenu">
      <div
        v-if="active"
        class="parent-submenu"
        :class="{ 'right-0': right, 'left-0': !right }"
      >
        <div class="submenu">
          <div class="submenu-title content-margin">
            <div class="c-text-subtitle c-text-gray-500">
              {{ name }}
            </div>
            <icon
              class="cursor-pointer"
              name="close"
              size="10"
              color="var(--c-color-gray)"
              @click.native="close()"
            />
          </div>
          <div class="bar w-full" />
          <div class="container-content-footer">
            <div class="content content-margin">
              <slot name="content" />
            </div>
            <div class="footer">
              <slot name="footer" />
            </div>
          </div>
        </div>
      </div>
    </transition>
    <div
      v-if="active"
      class="background"
      @click="close()"
    />
  </div>
</template>

<script>
import { Icon } from '@estrategiahq/coruja-web-ui';

export default {
  components: {
    Icon,
  },
  props: {
    name: {
      type: String,
      default: '',
    },
    right: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      active: false,
    };
  },
  methods: {
    close() {
      this.active = false;
    },
    open() {
      this.active = true;
    },
  },
};
</script>

<style>
.background-enter-active,
.parent-submenu-enter-active {
  transition: all 0.5s ease;
}
.background-leave-active,
.parent-submenu-leave-active {
  transition: all 0.3s ease;
}
.background-enter,
.background-leave-to {
  opacity: 0;
}
.parent-submenu-enter,
.parent-submenu-leave-to {
  transform: translateX(100%);
}
.background {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 40;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  background-color: var(--c-color-gray-500);
  opacity: 0.5;
}
.parent-submenu {
  z-index: 50;
  position: fixed;
  height: 100%;
  width: 35%;
}
.submenu {
  width: 100%;
  height: 100%;
  background-color: #fff;
  position: relative;
  transition: all 1s ease-in;
}
.submenu-title {
  display: flex;
  justify-content: space-between;
  padding-top: 3.25rem;
  padding-bottom: 2rem;
}
.content-margin {
  margin-left: 2.25rem;
  margin-right: 2rem;
}
.container-content-footer {
  overflow: auto;
  height: 100%;
  display: flex;
  flex-direction: column;
}
.content {
  padding-top: 2.5rem;
}
.footer {
  box-shadow: 0px 16px 48px rgba(34, 34, 34, 0.16);
  background-color: #fff;
  width: 100%;
  position: absolute;
  bottom: 0;
  padding-bottom: 1.25rem;
  padding-top: 1em;
}
</style>
